
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import TradesPurpleLayout from "@/components/Layout";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <TradesPurpleLayout>
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <h1 className="text-6xl font-bold text-purple-700 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">Page Not Found</h2>
        <p className="text-gray-600 mb-8 max-w-md">
          We couldn't find the page you're looking for. The postcode or tradesperson might have been moved or doesn't exist.
        </p>
        <Link to="/">
          <Button className="bg-purple-600 hover:bg-purple-700 text-white">
            <Home className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </Link>
      </div>
    </TradesPurpleLayout>
  );
}
